export const routes = {
  home: '/',
  login: '/auth/login',
  register: '/auth/register',
  forgot: '/auth/forgot',
  resetPassword: '/auth/reset-password',
  requestAccess: '/auth/request-access',
  invitationAccept: '/auth/invitation/accept',
  pending: '/auth/pending',
  denied: '/auth/denied',
  classroomEntry: '/auth/classroom',
  classroomToday: '/classroom/today',
  classroomSession: '/classroom/session',
  app: '/app',
  requests: '/app/requests',
  newRequest: '/app/requests/new',
  journals: '/app/journals',
  people: '/app/people',
  assistant: '/app/assistant',
  audit: '/app/audit',
  profile: '/app/profile',
  profileSection: (section: string) => `/app/profile/${section}`,
  profileExport: (kind: 'cv' | 'works' | 'data') => `/app/profile/export/${kind}`,
  publicProfile: (academiaId: string) => `/p/${academiaId}`,
  notifications: '/app/notifications',
  security: '/app/security',
  owner: '/app/owner',
  ownerModule: (module: string) => `/app/owner/${module}`,
  advisor: '/app/advisor',
  advisorModule: (module: string) => `/app/advisor/${module}`,
  supervisor: '/app/supervisor',
  supervisorModule: (module: string) => `/app/supervisor/${module}`,
  teacher: '/app/teacher',
  teacherModule: (module: string) => `/app/teacher/${module}`,
  researcher: '/app/researcher',
  researcherModule: (module: string) => `/app/researcher/${module}`,
  operationsPartner: '/app/operations',
  operationsPartnerModule: (module: string) => `/app/operations/${module}`,
  partner: '/app/partner',
  partnerModule: (module: string) => `/app/partner/${module}`,
  departmentHead: '/app/department-head',
  departmentLab: '/app/department-lab',
  studentLesson: '/app/lesson',
  doctoral: '/app/doctoral',
  doctoralModule: (module: string) => `/app/doctoral/${module}`,
  learner: '/app/learner',
  supervisedStudent: '/app/student',
  supervisedStudentModule: (module: string) => `/app/student/${module}`,
  courseStudent: '/app/course-student',
  courseStudentModule: (module: string) => `/app/course-student/${module}`,
  author: '/app/author',
  authorModule: (module: string) => `/app/author/${module}`,
  client: '/app/client',
  clientModule: (module: string) => `/app/client/${module}`,
  editor: '/app/editor',
  editorModule: (module: string) => `/app/editor/${module}`,
  projectMember: '/app/project-member',
  projectMemberModule: (module: string) => `/app/project-member/${module}`,
  portal: '/portal',
  portalSection: (section: string) => `/portal/${section}`,
  researchTools: '/app/research-tools',
} as const;


export const portalSections = [
  'home',
  'about',
  'news',
  'competitions',
  'materials',
  'education',
  'vacancies',
  'instructions',
  'contacts',
] as const;

export type PortalSection = (typeof portalSections)[number];

export const isPortalSection = (value: string | undefined): value is PortalSection =>
  typeof value === 'string' && (portalSections as readonly string[]).includes(value);
